import { createContext, ReactNode, useContext, useState } from 'react'

export interface TableState {
  hasHorizontalScroll: boolean
  setHasHorizontalScroll: (value: boolean) => void
}

const TableContext = createContext<TableState | undefined>(undefined)
TableContext.displayName = 'TableContext'

interface TableContextProviderProps {
  children: ReactNode
}

export const TableContextProvider: React.FC<TableContextProviderProps> = ({ children }) => {
  const [hasHorizontalScroll, setHasHorizontalScroll] = useState(false)

  return (
    <TableContext.Provider value={{ hasHorizontalScroll, setHasHorizontalScroll }}>
      {children}
    </TableContext.Provider>
  )
}

export function useTable(): TableState {
  const context = useContext(TableContext)

  if (!context) {
    throw new Error('useTable must be used within a TableContextProvider')
  }

  return context
}
